


import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { Text } from "react-internationalization";
import React, { Component } from "react";



class ProspectGuidelines extends Component {
  constructor(props) {
      super(props);
      this.state = {
        isExpanded: true,
      };
    }
  
    setExpanded = () => {
      this.setState({
        isExpanded: !this.state.isExpanded,
      });
    };
  render() {

      
      return (
          <div>
               <Text>
                  Click on (+) to view guidelines on filling and uploading the Prospect bulk load file.
              </Text>
                      {this.state.isExpanded ? (
          <AddCircleIcon style={{color:"#007bff"}} onClick={this.setExpanded} />
        ) : (
          <RemoveCircleIcon style={{color:"#007bff"}} onClick={this.setExpanded} />
        )}
                  
                  <div 
                className={
                    this.state.isExpanded
                      ? "panel-collapse collapse "
                      : "panel-collapse collapse-show font12px"
                  }
                id="Instructions">
                    <div class="mt-2"
                    // className="card-body"
                    >
                        <strong><Text id="bulkUpload.prospectguidelines"/></strong>
                        <div>
                        <p>1{" "}<Text id="bulkUpload.pguideline1"/>
                        <br/>
                        2{" "}<Text id="bulkUpload.guideline2"/><br/>
                        3{" "}<Text id="bulkUpload.guideline3"/>
                        <ul class="mb-0">
                                        <li><Text id="bulkUpload.pguideline3sub1"/></li>
                                    </ul>
                        4{" "}<Text id="bulkUpload.pguideline4"/>
                        <ul>
                                        <li><Text id="bulkUpload.pguideline4sub1"/></li>
                                        <li><Text id="bulkUpload.pguideline4sub2"/></li>
                                        <li><Text id="bulkUpload.pguideline4sub3"/></li>
                                        <li><Text id="bulkUpload.pguideline4sub4"/></li>
                                        <li><Text id="bulkUpload.pguideline4sub5"/></li>
                                        <li><Text id="bulkUpload.pguideline4sub6"/></li>
                                        <li><Text id="bulkUpload.pguideline4sub7"/></li>
                                        <li><Text id="bulkUpload.pguideline4sub8"/></li>
                                        <li><Text id="bulkUpload.pguideline4sub9"/></li>
                                        <li><Text id="bulkUpload.pguideline4sub10"/></li>
                                        <li><Text id="bulkUpload.pguideline4sub11"/></li>
                                        <li><Text id="bulkUpload.pguideline4sub12"/></li>
                                        <li><Text id="bulkUpload.pguideline4sub13"/></li>
                                        <li><Text id="bulkUpload.pguideline4sub14"/></li>
                                    </ul>            
                        </p>
                        
                                
                         </div>
                        
                    </div>
                </div>
          </div>
      );
  }
}



export default 
(ProspectGuidelines);
